import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//Icons
import { BsXLg, BsFillExclamationTriangleFill } from "react-icons/bs";

//APIS
import { seminerGetAll, seminerUpdate } from '../../../apis/seminer';

const Basvurular = () => {

    const [loading, setLoading] = useState(false) // Skleton için kullanılacak


    //STATES
    const [seminerLIST, setSeminerLIST] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [open, setOpen] = useState(false)
    const [seminerId, setSeminerId] = useState()
    const [aciklama, setAciklama] = useState("")


    //HANDLE FUNCTIONS

    const handleOnay = async (id) => {

        let result = await seminerUpdate(id, { seminerDurum: 2 })
        console.log(result)
        if (result.status === 200) {
            toast.success("Seminer başvurusu onaylandı", {
                position: toast.POSITION.TOP_CENTER
            });
            getSeminerLIST()
        }
    }
    const handleIptal = async () => {
        console.log(seminerId)
        if (aciklama === "") {
            return toast.warning("Lütfen bir açıklama giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        let result = await seminerUpdate(seminerId, { seminerDurum: 3, seminerDurumAciklama: aciklama })
        console.log(result)
        if (result.status === 200) {
            toast.success("Başvuru reddedildi", {
                position: toast.POSITION.TOP_CENTER
            });
            setOpenModal(false)
            setAciklama("")
            getSeminerLIST()
        }
    }

    const handleGerial = async (id) => {
        let result = await seminerUpdate(id, { seminerDurum: 1 })
        if (result.status === 200) {
            toast.success("İşlem iptal edildi", {
                position: toast.POSITION.TOP_CENTER
            });
            getSeminerLIST()
        }
    }


    //API FUNCTIONS

    const getSeminerLIST = async () => {
        setLoading(true)
        let result = await seminerGetAll(2)
        if (result.status === 200) {
            setSeminerLIST(result.data)
            setLoading(false)
        }else{
            setLoading(false)
        }
    }

    useEffect(() => {
        getSeminerLIST()
    }, []);


    return (
        <>
            <ToastContainer />
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500'>Gelen Başvurular</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                <div className='w-full'>
                                    <div className='bg-white rounded-lg p-4 min-h-0 overflow-x-auto mb-6'>
                                        <h1 className='mb-4 font-semibold'>Bekleyen Başvurular</h1>
                                        {
                                            loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                <table className='w-full table-auto'>
                                                    <thead className='bg-slate-100'>
                                                        <tr>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Başvuru No</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Öğrenci</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Enstitü / Dönem</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Durum</td>
                                                            <td className='px-4 py-2 whitespace-nowrap text-center'>İşlemler</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody className='text-xs'>
                                                        {
                                                            seminerLIST?.filter(item => item.seminerDurum === 1).length > 0 ? (
                                                                seminerLIST.filter(item => item.seminerDurum === 1).map((item, key) => (
                                                                    <tr key={key} className='even:bg-slate-50 odd:bg-white'>
                                                                        <td className='px-4 py-3 whitespace-nowrap underline'>
                                                                            {/* <strong>{item.seminerCode}</strong> */}
                                                                            <Link to={"/seminer-print/" + item.seminerCode} target='blank'>{item.seminerCode}</Link>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            <div>{item.ogrenci.ogrenciNo}</div>
                                                                            <div>{item.ogrenci.ogrenciAdiSoyadi}</div>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            <div>{item.enstituName}</div>
                                                                            <div>{item.donem?.donemName}</div>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            {
                                                                                item.seminerDurum === 1 ? (
                                                                                    <span className='bg-orange-200 text-orange-600 py-1 px-2 rounded-3xl'>Bekliyor</span>
                                                                                ) : item.seminerDurum === 2 ? (
                                                                                    <span className='bg-teal-200 text-teal-600 py-1 px-2 rounded-3xl'>Onaylandı</span>
                                                                                ) : (
                                                                                    <span className='bg-red-200 text-red-600 py-1 px-3 rounded-3xl'>Rededildi</span>
                                                                                )
                                                                            }
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap text-center space-x-2'>

                                                                            {
                                                                                item.seminerDurum === 1 ? (
                                                                                    <>
                                                                                        <button onClick={() => {
                                                                                            handleOnay(item.seminerId)
                                                                                        }} className='bg-teal-600 text-white hover:bg-teal-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-teal-400 outline-offset-2'>
                                                                                            Onayla
                                                                                        </button>
                                                                                        <button onClick={() => {
                                                                                            setSeminerId(item.seminerId)
                                                                                            setOpenModal(true)
                                                                                        }} className='bg-red-600 text-white hover:bg-red-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-red-400 outline-offset-2'>
                                                                                            Red
                                                                                        </button>
                                                                                    </>
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            handleGerial(item.seminerId)
                                                                                        }}
                                                                                        className='bg-red-600 text-white hover:bg-red-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-red-400 outline-offset-2'>
                                                                                        Gerial
                                                                                    </button>
                                                                                )
                                                                            }

                                                                            <button
                                                                                onClick={() => {
                                                                                    setSeminerId(item.seminerId)
                                                                                    setOpen(true)
                                                                                }}
                                                                                className='bg-sky-600 text-white hover:bg-sky-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-sky-400 outline-offset-2'>
                                                                                Görüntüle
                                                                            </button>

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={3} className='px-4 py-3'>Kayıt bulunamamıştır.</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }

                                    </div>
                                    <div className='bg-white rounded-lg p-4 min-h-0 overflow-x-auto mb-6'>
                                        <h1 className='mb-4 font-semibold'>Onaylanan Başvurular</h1>
                                        {
                                            loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                <table className='w-full table-auto'>
                                                    <thead className='bg-slate-100'>
                                                        <tr>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Başvuru No</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Öğrenci</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Enstitü / Dönem</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Durum</td>
                                                            <td className='px-4 py-2 whitespace-nowrap text-center'>İşlemler</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody className='text-xs'>
                                                        {
                                                            seminerLIST?.filter(item => item.seminerDurum === 2).length > 0 ? (
                                                                seminerLIST.filter(item => item.seminerDurum === 2).map((item, key) => (
                                                                    <tr key={key} className='even:bg-slate-50 odd:bg-white'>
                                                                        <td className='px-4 py-3 whitespace-nowrap underline'>
                                                                            {/* <strong>{item.seminerCode}</strong> */}
                                                                            <Link to={"/seminer-print/" + item.seminerCode} target='blank'>{item.seminerCode}</Link>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            <div>{item.ogrenci.ogrenciNo}</div>
                                                                            <div>{item.ogrenci.ogrenciAdiSoyadi}</div>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            <div>{item.enstituName}</div>
                                                                            <div>{item.donem.donemName}</div>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            {
                                                                                item.seminerDurum === 1 ? (
                                                                                    <span className='bg-orange-200 text-orange-600 py-1 px-2 rounded-3xl'>Bekliyor</span>
                                                                                ) : item.seminerDurum === 2 ? (
                                                                                    <span className='bg-teal-200 text-teal-600 py-1 px-2 rounded-3xl'>Onaylandı</span>
                                                                                ) : (
                                                                                    <span className='bg-red-200 text-red-600 py-1 px-3 rounded-3xl'>Rededildi</span>
                                                                                )
                                                                            }
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap text-center space-x-2'>

                                                                            {
                                                                                item.seminerDurum === 1 ? (
                                                                                    <>
                                                                                        <button onClick={() => {
                                                                                            handleOnay(item.seminerId)
                                                                                        }} className='bg-teal-600 text-white hover:bg-teal-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-teal-400 outline-offset-2'>
                                                                                            Onayla
                                                                                        </button>
                                                                                        <button onClick={() => {
                                                                                            setSeminerId(item.seminerId)
                                                                                            setOpenModal(true)
                                                                                        }} className='bg-red-600 text-white hover:bg-red-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-red-400 outline-offset-2'>
                                                                                            Red
                                                                                        </button>
                                                                                    </>
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            handleGerial(item.seminerId)
                                                                                        }}
                                                                                        className='bg-red-600 text-white hover:bg-red-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-red-400 outline-offset-2'>
                                                                                        Gerial
                                                                                    </button>
                                                                                )
                                                                            }
                                                                            <button
                                                                                onClick={() => {
                                                                                    setSeminerId(item.seminerId)
                                                                                    setOpen(true)
                                                                                }}
                                                                                className='bg-sky-600 text-white hover:bg-sky-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-sky-400 outline-offset-2'>
                                                                                Görüntüle
                                                                            </button>

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={3} className='px-4 py-3'>Kayıt bulunamamıştır.</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }

                                    </div>
                                    <div className='bg-white rounded-lg p-4 min-h-0 overflow-x-auto'>
                                        <h1 className='mb-4 font-semibold'>Rededilen Başvurular</h1>
                                        {
                                            loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                <table className='w-full table-auto'>
                                                    <thead className='bg-slate-100'>
                                                        <tr>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Başvuru No</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Öğrenci</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Enstitü / Dönem</td>
                                                            <td className='px-4 py-2 whitespace-nowrap'>Durum</td>
                                                            <td className='px-4 py-2 whitespace-nowrap text-center'>İşlemler</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody className='text-xs'>
                                                        {
                                                            seminerLIST?.filter(item => item.seminerDurum === 3).length > 0 ? (
                                                                seminerLIST.filter(item => item.seminerDurum === 3).map((item, key) => (
                                                                    <tr key={key} className='even:bg-slate-50 odd:bg-white'>
                                                                        <td className='px-4 py-3 whitespace-nowrap underline'>
                                                                            {/* <strong>{item.seminerCode}</strong> */}
                                                                            <Link to={"/seminer-print/" + item.seminerCode} target='blank'>{item.seminerCode}</Link>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            <div>{item.ogrenci.ogrenciNo}</div>
                                                                            <div>{item.ogrenci.ogrenciAdiSoyadi}</div>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            <div>{item.enstituName}</div>
                                                                            <div>{item.donem.donemName}</div>
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap'>
                                                                            {
                                                                                item.seminerDurum === 1 ? (
                                                                                    <span className='bg-orange-200 text-orange-600 py-1 px-2 rounded-3xl'>Bekliyor</span>
                                                                                ) : item.seminerDurum === 2 ? (
                                                                                    <span className='bg-teal-200 text-teal-600 py-1 px-2 rounded-3xl'>Onaylandı</span>
                                                                                ) : (
                                                                                    <span className='bg-red-200 text-red-600 py-1 px-3 rounded-3xl'>Rededildi</span>
                                                                                )
                                                                            }
                                                                        </td>
                                                                        <td className='px-4 py-3 whitespace-nowrap text-center space-x-2'>

                                                                            {
                                                                                item.seminerDurum === 1 ? (
                                                                                    <>
                                                                                        <button onClick={() => {
                                                                                            handleOnay(item.seminerId)
                                                                                        }} className='bg-teal-600 text-white hover:bg-teal-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-teal-400 outline-offset-2'>
                                                                                            Onayla
                                                                                        </button>
                                                                                        <button onClick={() => {
                                                                                            setSeminerId(item.seminerId)
                                                                                            setOpenModal(true)
                                                                                        }} className='bg-red-600 text-white hover:bg-red-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-red-400 outline-offset-2'>
                                                                                            Red
                                                                                        </button>
                                                                                    </>
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            handleGerial(item.seminerId)
                                                                                        }}
                                                                                        className='bg-red-600 text-white hover:bg-red-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-red-400 outline-offset-2'>
                                                                                        Gerial
                                                                                    </button>
                                                                                )
                                                                            }
                                                                            <button
                                                                                onClick={() => {
                                                                                    setSeminerId(item.seminerId)
                                                                                    setOpen(true)
                                                                                }}
                                                                                className='bg-sky-600 text-white hover:bg-sky-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-sky-400 outline-offset-2'>
                                                                                Görüntüle
                                                                            </button>

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={3} className='px-4 py-3'>Kayıt bulunamamıştır.</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            )
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
            <Transition.Root show={openModal} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={setOpenModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 "
                                            onClick={() => setOpenModal(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsFillExclamationTriangleFill className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                                            <Dialog.Title as="h3" className="text-base  leading-6 text-slate-700">
                                                Açıklama giriniz!
                                            </Dialog.Title>
                                            <div className="mt-2 w-full">
                                                <textarea onChange={(e) => setAciklama(e.target.value)} className='sd-form-input h-16'></textarea>
                                                <span className='text-xs text-slate-600'>Başvuru red edilecek emin misiniz?</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            onClick={() => handleIptal()}
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                        >
                                            Onayla
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => {
                                                setOpenModal(false)
                                                setAciklama("")
                                            }}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <div className="fixed inset-0" />

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                            <div className="px-4 sm:px-6">
                                                <div className="flex items-start justify-between">
                                                    <Dialog.Title className="text-base font-semibold leading-6 text-slate-500">
                                                    </Dialog.Title>
                                                    <div className="ml-3 flex h-7 items-center">
                                                        <button
                                                            type="button"
                                                            className="rounded-md bg-white text-slate-400 hover:text-slate-500"
                                                            onClick={() => setOpen(false)}
                                                        >
                                                            <span className="sr-only">Close panel</span>
                                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative mt-6 px-4 sm:px-6 text-slate-500">
                                                {
                                                    seminerLIST?.filter(item => item.seminerId === seminerId).map((item, key) => (
                                                        <div key={key} className='text-xs'>
                                                            <div className='space-y-1'>
                                                                <div className='font-semibold text-xl'>{item.ogrenci.ogrenciAdiSoyadi}</div>
                                                                <div className='divide-x-2'>
                                                                    <span className='pr-4'><a href='mailto:selim@odu.edu.tr'>{item.ogrenci.ogrenciEposta}</a></span>
                                                                    <span className='pl-4'>{item.ogrenci.ogrenciCepNo}</span>
                                                                </div>
                                                                <div>{item.ogrenci.ogrenciNo}</div>
                                                                <div>{item.enstituName}</div>
                                                                <div>{item.anabilimName} / {item.bilimsanatdaliName}</div>
                                                            </div>
                                                            <div className='mt-8'>
                                                                <h1 className='font-semibold text-sm text-slate-700 mb-4'>Seminer Detay</h1>
                                                                <div>
                                                                    <table className='w-full'>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className='border border-slate-200 p-2 font-semibold text-slate-700'>Seminer Türü</td>
                                                                                <td className='border border-slate-200 p-2'>{item.seminerTuru}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='border border-slate-200 p-2 font-semibold text-slate-700'>Seminer tarihi ve saati</td>
                                                                                <td className='border border-slate-200 p-2'>{item.seminerTarihi} - {item.seminerSaati}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='border border-slate-200 p-2 font-semibold text-slate-700'>Seminerin yapılacağı  yer</td>
                                                                                <td className='border border-slate-200 p-2'>{item.seminerYeri}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={2} className='border border-slate-200 p-2'>
                                                                                    <div className='mb-2 font-semibold text-slate-700'>Seminer Konusu</div>
                                                                                    <p>{item.seminerKonusu}</p>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>

                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}

export default Basvurular;
